import React from "react"

import ActivityBase from "@/components/activities/base"
import i18n from "@/i18n"

type EmailSentProps = {
  activity: any
  className?: string
}

const EmailSent = ({ activity, className }: EmailSentProps) => {
  const emailType = activity.parameters?.email_type as string | undefined
  const emailTypeName = emailType
    ? i18n.t(`app.activities.customer.email_sent.email_types.${emailType}`, { defaultValue: emailType })
    : ""

  return (
    <ActivityBase
      data-testid="panel-activity-customer-email-sent"
      activityKey={activity.key}
      text={i18n.react("app.activities.customer.email_sent.description", {
        emailTypeName,
      })}
      createdAt={activity.createdAt}
      className={className}
    />
  )
}

export default EmailSent
